﻿import type { CSSProperties, ReactNode } from 'react';
import './PulseHighlight.css';

interface PulseHighlightProps {
    active?: boolean;
    children: ReactNode;
    className?: string;
    style?: CSSProperties;
}

export default function PulseHighlight({ active, children, className, style }: PulseHighlightProps) {
    if (!active) {
        return <>{children}</>;
    }

    return (
        <span className={`fe-pulse-highlight${className ? ` ${className}` : ''}`} style={style}>
            {children}
        </span>
    );
}

